import Portfolios from "../Portfolios/Portfolios";
import {Link} from "react-router-dom";
import {useWindowWidth} from "../Context/WindowWidthContext";
import PortfolioImage from "../Portfolios/Entities/PortfolioImage";
import {ReactElement, useState} from "react";

function MenuItem({link, text, onClick}: { link?: string, text: string, onClick?: () => void }) {
    link ??= text;

    return (<li onClick={onClick}><span><Link to={`/${link}`}>{text}</Link></span></li>);
}

function HomeButton({isMobileMenu, onClick}: {isMobileMenu?: boolean, onClick?: () => void}) {
    if (isMobileMenu) {
        return (
            <li id="home" onClick={onClick}><span><Link to="/">home</Link></span></li>
        );
    }
    return (
        <li id="home"><Link to="/" id="home-button"/></li>
    );
}

function PortfolioDropdown({onItemClick}: {onItemClick?: () => void}) {
    return (
        <li id="menu-portfolio" className="dropdown">
            <span><a href="/index.php">portfolios</a></span>
            <ul className="dropdown-menu">
                {Portfolios.map(portfolio => ((
                    <li key={portfolio.path} onClick={onItemClick}><Link to={"/portfolio/" + portfolio.path}>{portfolio.name}</Link></li>
                )))}
            </ul>
        </li>
    );
}

function Menu({selectedPortfolioPiece}: { selectedPortfolioPiece: PortfolioImage | null }) {
    const windowWidth = useWindowWidth();
    const width = 460;

    const useHamburgerMenu = windowWidth <= width + (selectedPortfolioPiece?.pixelWidth ?? 0);

    const [hamburgerOpen, setHamburgerOpen] = useState(false);

    // Calculate dynamic max-height based on menu items
    // Matches the 52px desktop menu item height
    const mainMenuItems = 6; // home, portfolios, about, exhibits, news, contact
    const portfolioItems = Portfolios.length;
    const itemHeight = 52;
    const dynamicMaxHeight = (mainMenuItems + portfolioItems) * itemHeight;

    const hamburgerButton = (
        <li onClick={() => setHamburgerOpen(!hamburgerOpen)}>
            <span style={{cursor: 'pointer'}}>☰</span>
        </li>
    );

    const closeMenu = () => setHamburgerOpen(false);

    const menuItems: ReactElement = (
        <>
            <HomeButton isMobileMenu={useHamburgerMenu} onClick={useHamburgerMenu ? closeMenu : undefined}/>
            <PortfolioDropdown onItemClick={useHamburgerMenu ? closeMenu : undefined}/>
            <MenuItem text={"about"} onClick={useHamburgerMenu ? closeMenu : undefined}/>
            <MenuItem text={"exhibits"} onClick={useHamburgerMenu ? closeMenu : undefined}/>
            <MenuItem text={"news"} onClick={useHamburgerMenu ? closeMenu : undefined}/>
            <MenuItem text={"contact"} onClick={useHamburgerMenu ? closeMenu : undefined}/>
        </>
    );

    if (useHamburgerMenu) {
        return (
            <ul id="menu" className={`mobile ${hamburgerOpen ? 'active' : ''}`} style={{
                '--dynamic-max-height': `${dynamicMaxHeight}px`
            } as React.CSSProperties}>
                {hamburgerButton}
                {menuItems}
            </ul>
        );
    }

    return (
        <ul id="menu">
            {menuItems}
        </ul>
    );
}

export default Menu;